import { Section } from '@/components/ui/layouts/sections/Section';
import { carouselMiniCardsSettings } from '@mage-ui/styled-system/recipes';
import { InstancesCarousel } from '../InstancesCarousel';

export const MiniCardsLiteBlock = ({ data, ...props }) => {
  return (
    <Section
      heading={{
        title: data?.fields?.title,
        intro: data?.fields?.intro,
        meta: data?.fields?.meta_info,
        epi: data?.fields?.epi,
      }}
    >
      <InstancesCarousel
        indicatorThreshold={3}
        settings={carouselMiniCardsSettings()}
        instances={data?.relations?.MiniCardsLiteList}
        {...props}
      />
    </Section>
  );
};
